export const wizardStepsGS = Object.freeze({
  ELEMENT_COUNT: 'Gliederzahl',
  DIMENSIONS: 'Maße',
  SPACING: 'Teilung',
  WATER_CHAMBER_WIDTH: 'Wasserkammerbreite',
  COLUMN_SHAPE: 'Säulenform',
  CONNECTION_TYPE: 'Anschlussart',
  BACK_PLATE: 'Verwendetes Rückteil',
  MANUFACTURER: 'Hersteller',
});

export const wizardStepImagesGS = Object.freeze({
  GS_SPACING_LATERAL: new URL(
    '@/assets/img/radiators/GG/spacing.svg',
    import.meta.url
  ).href,
  GS_SPACING_GENERAL: new URL(
    '@/assets/img/radiators/GS/spacing/spacing_general.svg',
    import.meta.url
  ).href,
  GS_WATER_CHAMBER: new URL(
    '@/assets/img/radiators/GG/waterChamberWidth.svg',
    import.meta.url
  ).href,
  GS_DIMENSIONS: new URL(
    '@/assets/img/radiators/GS/dimensions.svg',
    import.meta.url
  ).href,
  GS_ELEMENT_COUNT: new URL(
    '@/assets/img/radiators/GS/element_count.svg',
    import.meta.url
  ).href,
});

export const connectionTypesGS = Object.freeze([
  {
    name: 'E',
    subtitle: 'Gleichseitiger Anschluss, mit oberem Vorlauf',
    value: 'E1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'E',
    subtitle: 'Untere Anbindung mit Trennscheibe im Vorlauf',
    value: 'E2',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E2.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'E',
    subtitle: 'Obere Vorlaufeinführung in Verbindung mit unterer Anbindung',
    value: 'E3',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E3.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'E',
    subtitle: 'Obere Vorlaufeinführung in Verbindung mit unterer Anbindung',
    value: 'E4',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E4.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'E',
    subtitle:
      'Untere Vorlaufeinführung Achtung! Keine HKV-Montage, siehe Handbuch',
    value: 'E5',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E5.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'W',
    subtitle: 'Vorlauf oben, Rücklauf unten',
    value: 'W1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_W1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'W',
    subtitle: 'Kurzschlussstrecke (Einrohrsystem)',
    value: 'W2',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_W2.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'W',
    subtitle: 'Reihenschaltung von mehreren Heizkörpern',
    value: 'W3',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_W3.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'W',
    subtitle:
      'Untere Vorlaufeinführung Achtung! Keine HKV-Montage, siehe Handbuch',
    value: 'W4',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_W4.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'R',
    subtitle: 'Beide Anschlüsse unten, links und rechts',
    value: 'R1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_R1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'R',
    subtitle: 'Kurzschlussstrecke (Einrohrsystem)',
    value: 'R2',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_R2.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'R',
    subtitle: 'Reihenschaltung von mehreren Heizkörpern',
    value: 'R3',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_R3.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'S',
    subtitle: 'Mit unterer Trennscheibe am Vorlauf oder mittig',
    value: 'S1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_S1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'S',
    subtitle:
      'Obere Einführung von Vor- und Rücklauf, obere Trennscheibe am Rücklauf',
    value: 'S2',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_S2.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'S',
    subtitle: 'Reihenschaltung mit Trennscheibe vorlaufseitig',
    value: 'S3',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_S3.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'M',
    subtitle: 'Mittenanschluss mit Ventileinsatz am Vorlaufanschluss',
    value: 'M1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_M1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'L',
    subtitle: 'Lanzenventil',
    value: 'L1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_L1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'L',
    subtitle: 'Sonderform Lanzenventil',
    value: 'L2',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_L2.svg',
      import.meta.url
    ).href,
  },
]);

export const radiatorColumnShapeGS = Object.freeze([
  {
    name: '1',
    subtitle: 'Symetrische einfache Form',
    value: 1,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_1.svg',
      import.meta.url
    ).href,
  },
  {
    name: '2',
    subtitle: 'Einfache Form, Rand glatt gekantet',
    value: 2,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_2.svg',
      import.meta.url
    ).href,
  },
  {
    name: '3',
    subtitle: 'Unsymmetrisch vorne glatt',
    value: 3,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_3.svg',
      import.meta.url
    ).href,
  },
  {
    name: '4',
    subtitle: 'Asymmetrisch hinten breiter',
    value: 4,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_4.svg',
      import.meta.url
    ).href,
  },
  {
    name: '5',
    subtitle: 'Randumkantung',
    value: 5,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_5.svg',
      import.meta.url
    ).href,
  },
]);

export const radiatorBackPlatesGS = Object.freeze([
  {
    name: 'PLAN',
    subtitle: 'PLAN',
    value: 'PLAN',
    image: new URL(
      '@/assets/img/radiators/common/backPlates/RT_01.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'PLANAD',
    subtitle: 'PLAN Rohradapter',
    value: 'PLANAD',
    image: new URL(
      '@/assets/img/radiators/common/backPlates/RT_02.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'PLANW',
    subtitle: 'PLAN + Wärmeleitblech',
    value: 'PLANW',
    image: new URL(
      '@/assets/img/radiators/common/backPlates/RT_03.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'PLANWS',
    subtitle: 'PLAN + Wärmeleitblech + Silikon',
    value: 'PLANWS',
    image: new URL(
      '@/assets/img/radiators/common/backPlates/RT_04.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'PROFIL',
    subtitle: 'PROFIL',
    value: 'PROFIL',
    image: new URL(
      '@/assets/img/radiators/common/backPlates/RT_05.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'RSH',
    subtitle: 'RSH',
    value: 'RSH',
    image: new URL(
      '@/assets/img/radiators/common/backPlates/RT_06.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'SSR',
    subtitle: 'SSR',
    value: 'SSR',
    image: new URL(
      '@/assets/img/radiators/common/backPlates/RT_07.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'SSRS',
    subtitle: 'SSR + Silikon',
    value: 'SSRS',
    image: new URL(
      '@/assets/img/radiators/common/backPlates/RT_08.svg',
      import.meta.url
    ).href,
  },
]);
